var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    { attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100" } },
    [
      _c("path", {
        attrs: {
          d:
            "M2.22,70a6.67,6.67,0,0,0,6.67,6.67H20.65c.66-5.63,5.16-10,10.6-10h37.5c5.44,0,9.94,4.37,10.6,10H91.11A6.67,6.67,0,0,0,97.78,70L100,61.11a6.67,6.67,0,0,0-6.67-6.66H10.48A20.25,20.25,0,0,1,14,36.58a8,8,0,0,0,2.57,1,7.78,7.78,0,1,0-6.11-9.15A7.7,7.7,0,0,0,11,33.21,24.66,24.66,0,0,0,5.91,54.49,6.67,6.67,0,0,0,0,61.11Z"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M21.64,50H78.36a19.05,19.05,0,0,0-16.8-14.64c-.07,3.47-11.56,12-11.56,12s-11.49-8.58-11.57-12A19.05,19.05,0,0,0,21.64,50Z"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M50,37.85c8.77,0,15.89-13.19,15.89-22a15.89,15.89,0,0,0-31.78,0C34.11,24.66,41.23,37.85,50,37.85Z"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M73.66,99.5,75,78.09c0-3.85-2.8-7-6.25-7H31.25c-3.45,0-6.25,3.13-6.25,7L26.34,99.5Z"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-664abae9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-664abae9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/icons/icon-speaker-podium.vue
// module id = null
// module chunks = 